import type { LauncherState } from '../driver-common/state';

export interface DvrConfig {
  /**
   * Whether the whole feature of DVR driver is enabled or not. It can be
   * disabled temporarily while still preserving other configuration.
   */
  enabled: boolean;

  /**
   * The absolute path of DVR executable required to run the DVR process.
   */
  dvrPath: string;

  headless: boolean;

  pythonPath: string;

  /**
   * List of locally reachable absolute paths with a valid preset configured,
   * that are selected by the user to be watched by Mimir Desktop for .prproj
   * files.
   */
  selectedWatchFolders: string[];

  /**
   * Maximum time in seconds to wait if DVR appears to be unresponsive.
   */
  timeout: number;
}

export const defaultDvrConfig: DvrConfig = {
  enabled: false,
  dvrPath: '',
  headless: true,
  pythonPath: '',
  selectedWatchFolders: [],
  timeout: 180,
};

export const dvrState: LauncherState = {
  pollingIntervalId: undefined,
  isProcessingAlready: false,
};
